import './host'

import { VirtualFeedService } from '@graft/nuget-gc.webportals.artifactfeeds'

import { getSessionToken } from '@common/helpers'
import { readGraftObject } from '@common/utils/readGraftObject'

import type { ModuleVersionInstance } from './artifactfeeds.type'
import { isArtifactFeedServiceConfigured } from './artifactfeeds.utils'

export async function getModuleVersionInstances(
  projectId: string,
  moduleVersionInstanceIds: string[]
): Promise<ModuleVersionInstance[]> {
  if (!projectId || moduleVersionInstanceIds.length === 0 || !isArtifactFeedServiceConfigured()) {
    return []
  }

  try {
    const token = await getSessionToken()
    const instances = await VirtualFeedService.getModuleVersionInstances(token, projectId, moduleVersionInstanceIds)

    if (!instances?.length) {
      return []
    }

    return Promise.all(instances.map((instance) => readGraftObject<ModuleVersionInstance>(instance)))
  } catch (error) {
    console.error('Failed to get module version instances:', error)
    return []
  }
}
